import useGoBack from "src/hook/useGoBackInventory";
import FillEmissionTable from "./components/FillEmissionTable";
import { excelStore } from "src/stores/excel-store.interface";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

const FillEmission = () => {
  const currentYear = new Date().getFullYear();
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);
  useGoBack();

  return <FillEmissionTable />;
};

export default FillEmission;
